module.exports = __webpack_public_path__ + "img/arrow-down-up.a3b5d9cb.svg";